var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import format from 'string-format';
import Popover from '@mui/material/Popover';
import MenuList from '@mui/material/MenuList';
import { OGNavMenuItem } from '@opengear/navigation';
import ToggleButton from '@mui/material/ToggleButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import { useUIPermissions } from '@/api/sessions/self/ui';
import { useDeleteNode } from '@/api/nodes';
import { useAnchorOpen, useOpen } from '@/hooks/open';
import { NODES_ROUTE } from '@/constants/routes';
import { ConfirmationModal } from '@/components/confirmation-modal';
var ID = 'node-top-menu';
export function DeleteNodeButton(_a) {
    var _this = this;
    var nodeId = _a.nodeId, handleClose = _a.handleClose, disabled = _a.disabled;
    var t = useTranslation().t;
    var _b = useOpen(), dialogOpen = _b.open, dialogHandleClose = _b.handleClose, dialogHandleOpen = _b.handleOpen;
    var _c = __read(useState(false), 2), submitting = _c[0], setSubmitting = _c[1];
    var deleteNode = useDeleteNode();
    var navigate = useNavigate();
    // delete handler
    var handleNodeDelete = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitting(true);
                    return [4 /*yield*/, deleteNode(nodeId)];
                case 1:
                    success = _a.sent();
                    setSubmitting(false);
                    handleClose();
                    if (success) {
                        navigate(NODES_ROUTE);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [deleteNode, handleClose, navigate, nodeId]);
    // cancel handler
    var handleCancel = useCallback(function () {
        dialogHandleClose();
        handleClose();
    }, [dialogHandleClose, handleClose]);
    return (_jsxs(_Fragment, { children: [_jsx(ConfirmationModal, __assign({ title: t('components.nodes.remove_modal.title'), confirmLabel: t('global.buttons.remove'), onClose: handleCancel, onConfirm: handleNodeDelete, open: dialogOpen, disabled: submitting || disabled }, { children: _jsx(DialogContentText, { children: format(t('components.nodes.remove_modal.message'), nodeId !== null && nodeId !== void 0 ? nodeId : '') }) })), _jsxs(OGNavMenuItem, __assign({ autoFocus: true, disabled: disabled, onClick: dialogHandleOpen, "aria-label": t('pages.node.topbar.node_menu.menu_items.unenroll_node') }, { children: [_jsx(DeleteIcon, { fontSize: "medium", sx: { marginRight: 0.5 } }), t('pages.node.topbar.node_menu.menu_items.unenroll_node')] }))] }));
}
export function NodeTopMenu(_a) {
    var nodeId = _a.nodeId, rights = _a.rights;
    var t = useTranslation().t;
    var _b = useAnchorOpen(), anchorEl = _b.anchorEl, open = _b.open, handleClose = _b.handleClose, handleOpen = _b.handleOpen;
    var _c = useUIPermissions(), isLoadingPermissions = _c.isLoadingPermissions, isPrimary = _c.isPrimary;
    var canDelete = rights && rights.delete && isPrimary;
    return (_jsxs(_Fragment, { children: [_jsx(ToggleButton, __assign({ id: "".concat(ID, "-button"), "aria-expanded": open, "aria-haspopup": true, "aria-label": t('pages.node.topbar.node_menu.button'), disabled: isLoadingPermissions || !rights, selected: open, sx: { paddingX: 1, paddingY: 0.7 }, value: "checked", onClick: handleOpen }, { children: _jsx(MoreVertIcon, {}) })), _jsx(Popover, __assign({ open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                } }, { children: _jsx(MenuList, __assign({ "aria-label": t('pages.node.topbar.node_menu.label'), sx: { 'paddingX': '1px', 'paddingY': 0, 'width': '180px', '& .MuiMenuItem-root': { minWidth: 'auto' } } }, { children: _jsx(DeleteNodeButton, { nodeId: nodeId, handleClose: handleClose, disabled: !canDelete }) })) }))] }));
}
